import BaseApi from './BaseApi'

class AdminApi extends BaseApi {
  createAgency (agencyCreationObj) {
    return this.post('admin/agency', agencyCreationObj)
  }

  disableAgency (agencyId) {
    return this.post(`agencies/${agencyId}/disable`)
  }

  enableAgency (agencyId) {
    return this.post(`agencies/${agencyId}/enable`)
  }

  getAgency (agencyId) {
    return this.get(`agencies/${agencyId}`)
  }

  editAgency (agencyId, agencyEditedObj) {
    return this.put(`agencies/${agencyId}`, agencyEditedObj)
  }

  createAdminUser (userIbj) {
    return this.post('users/createAdmin', userIbj)
  }

  createAgent (agencyId, agentCreationObj) {
    return this.post(`agencies/${agencyId}/agent`, agentCreationObj)
  }

  getAgent (agentId) {
    return this.get(`agents/${agentId}`)
  }

  editAgent (agentId, agentObject) {
    return this.put(`agents/${agentId}`, agentObject)
  }

  downloadStatement (agencyId, month) {
    const url = `agencies/${agencyId}/commissions/generate`
    const method = 'post'
    const data = { month }
    return this.downloadAsFile(
      { url, method, data },
      'application/pdf',
      `${month}.pdf`
    )
  }

  disableAgent (agentId) {
    return this.post(`agents/${agentId}/disable`)
  }

  enableAgent (agentId) {
    return this.post(`agents/${agentId}/enable`)
  }

  disableUser (userId) {
    return this.post(`users/${userId}/disable`)
  }

  enableUser (userId) {
    return this.post(`users/${userId}/enable`)
  }
}

export default new AdminApi()
